const PENDING_RETRY_REQUESTED_KEY = 'pos-ident-pending-retry-requested';

export const posIdentPendingRetry = {
	isRequested: (): boolean => {
		try {
			return sessionStorage.getItem(PENDING_RETRY_REQUESTED_KEY) === 'true';
		} catch {
			return false;
		}
	},
	markRequested: (): void => {
		try {
			sessionStorage.setItem(PENDING_RETRY_REQUESTED_KEY, 'true');
		} catch {}
	},
	reset: (): void => {
		try {
			sessionStorage.removeItem(PENDING_RETRY_REQUESTED_KEY);
		} catch {}
	}
};
